export default "__VITE_ASSET__cea40450__"